module.exports = __webpack_public_path__ + "static/media/R-360HD_EC_CrossSection.70cab9b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/frFR/R-360HD_EC_CrossSection.png
// module id = 922
// module chunks = 0